"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUERY = exports.CHIP_HEIGHT = void 0;
const QUERY = exports.QUERY = 'query';
const CHIP_HEIGHT = exports.CHIP_HEIGHT = 35;
//# sourceMappingURL=constants.js.map